import { _ } from '../model/ccc'
import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { getLifeDateFormatted } from './getLifeDateFormatted'
import { isDead } from './isDead'

export function getLifeAndDeathFormatted(data: IData, person: IPerson) {
	return (
		<>
			<b>{getLifeDateFormatted({ data, person })}</b>{' '}
			{person.birthPlace ? (
				<small>({person.birthPlace})</small>
			) : (
				<small class={_.ccc_unknown}>(Ismeretlen helyen)</small>
			)}{' '}
			–{' '}
			{!isDead(data, person) ? (
				''
			) : (
				<>
					<b>{getLifeDateFormatted({ data, person, isDeath: true })}</b>{' '}
					{person.deathPlace ? (
						<small>({person.deathPlace})</small>
					) : (
						<small class={_.ccc_unknown}>(Ismeretlen helyen)</small>
					)}
				</>
			)}
		</>
	)
}
